import React from 'react';
import { Link } from 'react-router-dom';

import Rodape from '../../components/Rodape';
import Cabecalho from '../../components/cabecalho/Cabecalho';
import Inicio from '../../components/Inicio';
import Contato from '../../components/Contato';
import Indicadores from '../../components/Indicadores';
import Planos from '../../components/Planos';
import Portifolio from '../../components/Portifolio';
import '../../estilo.css';

const siteButtons = [
  { titulo: 'SOBRE', href: '#about', action: null },
  { titulo: 'INDICADORES', href: '#indicadores', action: null },
  { titulo: 'PORTFÓLIO', href: '#portfolio', action: null },
  { titulo: 'CONTATO', href: '#contact', action: null },
  { titulo: 'PLANOS', href: '#planos', action: null },
  { titulo: 'CADASTRO', href: '/cadastro', action: null },
  { titulo: 'LOGIN', href: '/login', action: null },
];

export default function Home() {
  return (
    <div className="App">
      <Cabecalho buttonList={siteButtons} />

      <Inicio />
      <Indicadores />
      <Portifolio />
      <Planos />
      <Contato />
      <Rodape />

      <Link to="/login" className="login-button">LOGIN</Link>
    </div>
  );
}
